import React from 'react';
import { NuvoThemeProvider } from '@nuvolo/nuux-theme';
import AwsApolloProvider from '#/app/providers/AwsApolloProvider';
import RouteProvider from '#/app/providers/RouteProvider';
import CognitoAuthProvider from './app/providers/CognitoAuthProvider';
import FullscreenProvider from '#/app/providers/FullscreenProvider';
import useClientTheme from '#/common/hooks/useClientTheme';
import SessionProvider from './app/providers/SessionProvider';

const App: React.FC = () => {
  const { theme } = useClientTheme();
  return (
    <NuvoThemeProvider theme={theme}>
      <CognitoAuthProvider>
        <AwsApolloProvider>
          <SessionProvider>
            <RouteProvider />
          </SessionProvider>
        </AwsApolloProvider>
      </CognitoAuthProvider>
    </NuvoThemeProvider>
  );
};

export default React.memo(App);
